import { Config } from '../types';
import keys from '../mumbai/keys';
import contracts from './contracts';
import pools from '../mumbai/pools';
import tokenlists from '../mumbai/tokenlists';
import tokens from '../mumbai/tokens';

const config: Config = {
  key: '80002',
  chainId: 80002,
  layerZeroChainId: 137,
  supportsVeBalSync: false,
  chainName: 'Amoy',
  name: 'Polygon Amoy Testnet',
  shortName: 'Polygon Amoy',
  monorepoName: 'amoy',
  slug: 'amoy',
  network: 'amoy',
  trustWalletNetwork: 'amoy',
  unknown: false,
  visibleInUI: true,
  testNetwork: true,
  rpc: `https://rpc-amoy.polygon.technology/`,
  ws: `wss://polygon-amoy-bor-rpc.publicnode.com`,
  publicRpc: 'https://rpc-amoy.polygon.technology/',
  explorer: 'https://amoy.polygonscan.com',
  explorerName: 'Amoy',
  subgraph:
    'https://api.thegraph.com/subgraphs/name/balancer-labs/balancer-arbitrum-v2',
  balancerApi: 'https://api.balancer.fi',
  poolsUrlV2: '',
  subgraphs: {
    main: [
      'https://api.thegraph.com/subgraphs/name/balancer-labs/balancer-arbitrum-v2',
    ],
    aave: '',
    gauge:
      'https://api.thegraph.com/subgraphs/name/balancer-labs/balancer-gauges-arbitrum',
    blocks:
      'https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-one-blocks',
  },
  bridgeUrl: 'https://bridge.arbitrum.io/',
  supportsEIP1559: false,
  supportsElementPools: false,
  blockTime: 2,
  nativeAsset: {
    name: 'Matic',
    address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    symbol: 'MATIC',
    decimals: 18,
    deeplinkId: 'matic',
    logoURI: 'tokens/matic.svg',
    minTransactionBuffer: '0.1',
  },
  vaultToken: {
    name: 'Vault',
    address: '0x66adFDc8CfCEa9Db7D5c76E1467F41394f95E88D',
    managerAddress: '0x2f9c74C4aB5676c6a2965B4a0FD520e3342A6362',
    symbol: 'VAULT',
    decimals: 6,
    assetDecimals: 6,
    assetSymbol: 'USC-Amoy',
    assetAddress: '0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582',
    logoURI: 'tokens/celo.png',
    poolId: 493,
  },

  thirdParty: {
    coingecko: {
      nativeAssetId: 'ethereum',
      platformId: 'amoy',
    },
    apyVision: {
      networkName: 'amoy',
    },
  },
  addresses: {
    ...contracts,
  },
  pools,
  tokens,
  keys,
  gauges: {
    type: 3,
    weight: 0,
  },
  tokenlists,
  rateProviders: {},
};

export default config;
